module.exports = __webpack_public_path__ + "static/team8-85e6410a4cbd13049b9793e8d0d8cc0f.jpg";